import React from 'react';
import { MenuProps } from 'antd';
import { StyledMenu } from './MenuStyles';
import { ItemType } from 'antd/es/menu/interface';

export type IMenu = MenuProps;
export type IMenuItemType = ItemType;

const Menu = ({ ...props }: IMenu) => <StyledMenu {...props} />;

export default Menu;
